import { Mixins, Component, Ref, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import SignInUsernameInput from '@/views/Authentication/components/signInUsernameInput/signInUsernameInput.vue'
import Authentication from '@/views/Authentication/models/authentication'

@Component({
    components: { SignInUsernameInput },
})
export default class ResetPassword extends Mixins<MixinInterface>() {
    signInUsername: any = ''
    loading = false
    valid = false
    usernameRateLimited = false
    retryAfter: number | null = null
    errorCode = ''

    @Ref('form') readonly form!: HTMLFormElement

    @Watch('signInUsername')
    resetInvalid() {
        this.errorCode = ''
    }

    async resetPassword(event?: any) {
        event ? event.preventDefault() : null

        this.valid = this.form.validate()

        if (this.valid && !this.loading) {
            this.loading = true

            let res = await Authentication.passwordReset(this.sanitizeUsername(this.signInUsername))

            if (res.status == '202') {
                this.$router.push({
                    name: 'reset-password-link-sent',
                    query: { username: this.sanitizeUsername(this.signInUsername) },
                })
            } else if (res.code == 'usernameRateLimited') {
                this.usernameRateLimited = true
                this.retryAfter = res['retryAfter']
                let timer = this.retryAfter ? this.retryAfter * 1000 : 1000
                let interval = setInterval(() => {
                    this.retryAfter = this.retryAfter ? this.retryAfter - 1 : null
                }, 1000)

                setTimeout(() => {
                    clearInterval(interval)
                    this.retryAfter = null
                    this.usernameRateLimited = false
                }, timer)
            } else if (typeof res.code == 'string') {
                this.errorCode = res.code
            }

            this.loading = false
        } else {
            for (const input of this.form.inputs) {
                if (!input.valid) {
                    input.focus()
                    break
                }
            }
        }
    }

    // LIFESYCLE
    async mounted() {
        if (this.$route.query.username) {
            this.signInUsername = this.$route.query.username
            await this.resetPassword()
        }
    }
}
